import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import Facebook from './Facebook'
import LinkedIn from './LinkedIn'
import X from './X'
import { IconProps } from 'blaze-ui/icons/Types'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { ChannelIcon } from 'components/ChannelIcon/ChannelIcon'
import { GoHighLevel, GoogleDrive, Mailchimp, Shopify, TikTokBrand, Wix, YouTubeBrand } from 'blaze-ui/icons'
import MetaBrand from 'blaze-ui/icons/20/MetaBrand'
import { WordPressBrand } from 'blaze-ui/icons/35/WordPressBrand'
import FacebookMessenger from './FacebookMessenger'
import GoogleAnalytics2 from 'blaze-ui/icons/20/GoogleAnalytics2'
import { InstagramBrand } from 'blaze-ui/icons/35'

export type PlatformIconKey = ExternalIntegrationEnum | 'facebook_messenger'

const platformIconMap: Record<PlatformIconKey, React.FC<IconProps>> = {
  [ExternalIntegrationEnum.Facebook]: Facebook,
  [ExternalIntegrationEnum.Instagram]: InstagramBrand,
  [ExternalIntegrationEnum.X]: X,
  [ExternalIntegrationEnum.LinkedIn]: LinkedIn,
  [ExternalIntegrationEnum.TikTok]: TikTokBrand,
  [ExternalIntegrationEnum.YouTube]: YouTubeBrand,
  [ExternalIntegrationEnum.Mailchimp]: Mailchimp,
  [ExternalIntegrationEnum.Google]: GoogleAnalytics2,
  [ExternalIntegrationEnum.GoogleDrive]: GoogleDrive,
  [ExternalIntegrationEnum.MetaAds]: MetaBrand,
  [ExternalIntegrationEnum.GoHighLevel]: GoHighLevel,
  [ExternalIntegrationEnum.WordPress]: WordPressBrand,
  [ExternalIntegrationEnum.Wix]: Wix,
  [ExternalIntegrationEnum.Shopify]: Shopify,
  facebook_messenger: FacebookMessenger,
}

interface Props {
  platform: PlatformIconKey
  size?: number
  channel?: ChannelType
}

export const RoundedPlatformIcon = ({ platform, size = 20, channel }: Props) => {
  const Component = platformIconMap[platform]

  if (!Component) {
    if (channel) return <ChannelIcon size={size} channel={channel} />

    return null
  }

  return <Component size={size} />
}
